import ApiService from "../../common/services/ApiService";

const api = new ApiService();

export const getProgramRegistrations = async () => {
   try {
      const programRegistrations = await api.query(`/api/v2/registrations?q[status_eq]=pending&per_page=25&q[s]=created_at+asc`);
      return programRegistrations.data;
    } catch (error) {
    } 
}

export const getProgramRegistration = async (id) => {
   try {
      const programRegistration = await api.query(`/api/v1/programs/${id}`);
      return programRegistration.data;
    } catch (error) {
    } 
}
